import {globalWindow} from '../../helpers/browser/browserHelpers';
import {FrontConfig} from '../../helpers/bundler/bundlerDefineConfig';

declare global {
  interface Window {
    currentVersion: () => string;
  }
}

let value: string;

export function setupBuildVersion(buildVersion: string) {
  value = buildVersion;
}

export function getBuildVersion() {
  return value || 'unknown';
}

globalWindow.currentVersion = () =>
  `Git Commit: ${FrontConfig.GIT_COMMIT}\r\nBuild Timestamp: ${FrontConfig.BUILD_TIMESTAMP}`;
